<template>
      <MainContent>
      <div>
        <b-card no-body >
          <nx-bform
           ref="form"
          @submit="confirm"
           >
            <h5>{{$t('invitationCode')}}</h5>
            <nx-bform-server-errors name="server-errors" />
            <b-input-group>
              <b-form-input
                v-model="invitationCode"
                :placeholder="$t('placeholder')"
              />
            </b-input-group>
            <CaptchaFormGroup
             style="padding-top :50px"
              label-cols="2"
              label-align="left"
              v-model="captcha"
              @change-token="captchaToken = $event.token"
              required
            />
            <b-form-group class="mt-2 justify-content-end">
              <b-button
                class="bd-button mr-2"
                 type="submit"
                >{{$t('confirm')}}</b-button
              >
              <b-button variant="danger" @click="back"
                >{{$t('cancel')}}</b-button
              >
            </b-form-group>
          </nx-bform>
        </b-card>
      
      </div>
      </MainContent>
</template>
<script>

import MainContent from "../../../components/main/MainContent";
import LoginIAMSmartPendingView from "../../../locales/modules/login/views/LoginIAMSmartPendingView";
import { IAmSmartQrCodeApi, CPSRequestRegistrationApi, MemberAccountInfoSettingApi } from "@/api";
import CaptchaFormGroup from "@/forms/common/CaptchaFormGroup";
import {
  IAMSmartProfileResultProvider,
  IAMSmartAuthApi,
  IAMSmartButton,
} from "@nextore/iam-smart";
export default {
  components: {
    MainContent,
    CaptchaFormGroup
  },
  props: {
    businessId: {
      tpye: String,
    },
    ecert: false,
    errorMsg: {},
    openIAmSmartAppUrl: {},
  },
  computed: {
    isMobile() {
      let ua = navigator.userAgent;
      let ipad = ua.match(/(iPad).*OS\s([\d_]+)/),
        isIphone = ua.match(/(iPhone\sOS)\s([\d_]+)/),
        isAndroid = ua.match(/(Android)\s+([\d.]+)/),
        isMobile = ipad || isIphone || isAndroid;
      return !!isMobile;
    },
  },
  data() {
    return {
      invitationCode: null,
      show: false,
      getIAmSmartUrl: '',
      userEngName:"",
      captcha: "",
      captchaToken: "",
    };
  },
  async created() {

  },
  beforeMount(){
    var lang = this.$route.query.lang;
    if(lang) {
      this.$root.$i18n.locale = lang;
    }
  },
  methods: {
    async success({ businessId }) {
      console.log("success", businessId);
      this.redirect(this.invitationCode, businessId,this.userEngName)
      //this.$successToast(this.$t("InvitationMsgTitle"), this.$t("sucessMsg"));
      //this.back();
      let lang = this.$i18n.locale.replace(/_/i, '-');
      await MemberAccountInfoSettingApi.editLanguage(lang);
      
    },
    error({ businessId, errorMsg }) {
      console.log("error", errorMsg);
      this.$dangerToast(this.$t("InvitationMsgTitle"), errorMsg);
      this.back();
    },
    async confirm() {
      var res = await CPSRequestRegistrationApi.validateInvitationCode(
        this.invitationCode, this.captchaToken
      );
      if (res.data == "Valid") {
      
          this.redirect(this.invitationCode, null)
        
      } else {
        this.$dangerToast(this.$t("InvitationMsgTitle"), this.$t("failCode"));
      }
      
    },
    async iamsmartprofile() {
      document.location.href = this.openIAmSmartAppUrl;
    },
    back() {
      this.$router.push({
        name: "LoginCps",
      });
    },
    async redirect(invitationCode, businessId){
   
      this.$router.push({
        name: "ERegistrationCPSRegister",
        params: {
          invitationKey: invitationCode,
          businessId: businessId
        },
      });
     
    }
  },
  i18n: {
    messages: LoginIAMSmartPendingView,
  },
};
</script>
<style>
.green-text {
  color: #2b7366;
}

.header {
  background-color: #2b7366;
  color: white;
  font-size: 24px;
}

.info-header {
  text-align: center;
  background-color: #005d99;
  /*margin: auto;*/
}
.info-btn {
  text-align: center;
  margin-bottom: 30px;
}
.info-btn button {
  color: #fff;
  font-weight: 800;
  padding: 8px;
  border-radius: 0.25rem;
  background-color: #2b7366;
  border: none;
}
</style>

<i18n src="@/locales/actions.locale"></i18n>

<i18n src="@/public/locales/modules/login/views/LoginIAMSmartInvitationView.json" />